import { Link } from "react-router-dom";
import { money0 } from "../../api";
import { HomeSection, Metric } from "./HomeBits";

const PERIODS = [["month", "This month"], ["last_month", "Last month"], ["quarter", "Quarter"], ["year", "Year"]];

export function PeriodSwitch({ value, onChange }) {
  return (
    <div className="pill-group" role="tablist" data-testid="period-selector">
      {PERIODS.map(([v, l]) => <button key={v} type="button" role="tab" aria-selected={value === v} onClick={() => onChange(v)} className={`pill !py-1 !text-[11.5px] ${value === v ? "pill-active" : ""}`} data-testid={`period-selector-${v.replace("_", "-")}`}>{l}</button>)}
    </div>
  );
}

// Six figures, one period. Everything deeper lives in Reports.
export function Performance({ perf, period, onPeriod, className = "" }) {
  const p = perf;
  const marginTone = p.gross_margin >= p.target_margin ? "pos" : p.gross_profit > 0 ? "warn" : undefined;
  return (
    <HomeSection title="Business performance" testid="business-performance" className={className} action={<><span className="hidden sm:block"><PeriodSwitch value={period} onChange={onPeriod} /></span><Link to="/reports" className="btn-ghost btn-sm whitespace-nowrap" data-testid="view-analytics-link">Full analytics →</Link></>}>
      <div className="border-b border-line px-4 py-2 sm:hidden"><PeriodSwitch value={period} onChange={onPeriod} /></div>
      <div className="metric-grid" data-period={period}>
        <Metric label="Revenue" value={money0(p.revenue)} sub={`Invoiced · ${p.label.toLowerCase()}`} to="/money/invoices" testid="metric-revenue" />
        <Metric label="Gross profit" value={money0(p.gross_profit)} sub={p.gross_profit ? `${p.gross_margin}% margin · target ${p.target_margin}%` : "No completed work yet"} tone={marginTone} to="/money/profitability" testid="metric-gross-profit" />
        <Metric label="Jobs won" value={p.jobs_won} sub={p.quotes_sent ? `${p.quotes_sent} quotes sent` : "No quotes sent"} to="/deals/quotes?status=accepted" testid="metric-jobs-won" />
        <Metric label="Jobs in progress" value={p.jobs_in_progress} sub="On site now" to="/jobs?status=in_progress" testid="metric-jobs-in-progress" />
        <Metric label="Outstanding invoices" value={money0(p.outstanding)} sub={p.overdue ? `${money0(p.overdue)} overdue` : `${p.outstanding_count} open`} tone={p.overdue ? "neg" : undefined} to={p.overdue ? "/money/invoices?status=overdue" : "/money/invoices"} testid="metric-outstanding" />
        <Metric label="Cash collected" value={money0(p.cash_collected)} sub={`Payments received · ${p.label.toLowerCase()}`} to="/money/payments" testid="metric-cash-collected" />
      </div>
    </HomeSection>
  );
}

// Estimating workspace: the quote pipeline instead of the P&L.
export function Pipeline({ perf, active, className = "" }) {
  const conv = perf.quotes_sent ? Math.round((perf.jobs_won / perf.quotes_sent) * 100) : 0;
  return (
    <HomeSection title="Quote pipeline" testid="quote-pipeline" className={className} action={<Link to="/deals/quotes" className="btn-ghost btn-sm" data-testid="view-quotes-link">All quotes →</Link>}>
      <div className="metric-grid metric-grid-4">
        <Metric label="Awaiting customer" value={active.quotes_awaiting} sub="Sent, not yet decided" to="/deals/quotes?status=sent" testid="metric-quotes-awaiting" />
        <Metric label="Quotes sent" value={perf.quotes_sent} sub={perf.label} to="/deals/quotes" testid="metric-quotes-sent" />
        <Metric label="Won" value={perf.jobs_won} sub={`${conv}% conversion`} tone={conv >= 40 ? "pos" : undefined} to="/deals/quotes?status=accepted" testid="metric-quotes-won" />
        <Metric label="Revenue quoted → invoiced" value={money0(perf.revenue)} sub={perf.label} to="/money/invoices" testid="metric-quoted-revenue" />
      </div>
    </HomeSection>
  );
}
